import type { PropsWithChildren } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import type { Props } from 'react-infinite-scroll-component'
import styled from 'styled-components'

interface InfinityScrollProps {
  length: number
  isLast: boolean
  reverse?: boolean
  next: () => void
}

export function InfinityScroll({ children, length, isLast, reverse, next }: PropsWithChildren<InfinityScrollProps>) {
  const InfiniteScrollProps: Omit<Props, 'children'> = {
    next,
    scrollableTarget: 'infinity-scroll-target',
    dataLength: length,
    hasMore: !isLast,
    loader: null,
  }

  if (reverse) {
    return (
      <ReverseContainer>
        <InfiniteScroll {...InfiniteScrollProps} inverse={true}>
          {children}
        </InfiniteScroll>
      </ReverseContainer>
    )
  }

  return <InfiniteScroll {...InfiniteScrollProps}>{children}</InfiniteScroll>
}

const ReverseContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  overflow-y: auto;
`
